import React from 'react'
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI.js'
import PageTitleUI from '../../../widgets/output/PageTitleUI'
import CardUI from '../../../widgets/layout/CardUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'

const AccountDetailPageUI = ({context, account, onRefreshClick}) =>
  <SuperUserAccountPageUI context={context} className='pg_su_acc' backLink='/su/accounts'
    headerText={account && account.accountName} centered={!account}
    account={account} page='360'
  >
    {
      !account &&
      <SpinnerComponentUI />
    }
    {
      account &&
      <div>
        <PageTitleUI context={context} goBack={true} backLink='/su/accounts' titleText={account && account.accountName} />

        <OnboardingUI context={context} account={account} />
        <DataCollectionUI context={context} account={account} />
        <TermSheetUI context={context} account={account} />
        <DocumentSigningUI context={context} account={account} />
        <ConditionPrecedentUI context={context} account={account} />
        <DisbursementUI context={context} account={account} />
      </div>
    }
  </SuperUserAccountPageUI>

const OnboardingUI = ({context, account}) =>
  <CardUI className='g_m_top_100' title='Onboarding'>
  </CardUI>

  const DataCollectionUI = ({context, account}) =>
    <CardUI className='g_m_top_100' title='Data collection'>
    </CardUI>

  const TermSheetUI = ({context, account}) =>
    <CardUI className='g_m_top_100' title='Term sheet'>
    </CardUI>

  const DocumentSigningUI = ({context, account}) =>
    <CardUI className='g_m_top_100' title='Document signing'>
    </CardUI>

  const ConditionPrecedentUI = ({context, account}) =>
    <CardUI className='g_m_top_100' title='Condition precedent'>
    </CardUI>

  const DisbursementUI = ({context, account}) =>
    <CardUI className='g_m_top_100' title='Disbursement'>
    </CardUI>

export default AccountDetailPageUI
